import { Button } from "@svea/design-system-components-react";
import { Checkbox, FormControlLabel, useText } from "@sveabank/cc-common";
import { useState } from "react";
import SigningModal from "../signing-modal";

type Props = {
	signAction: () => Promise<void>;
	isSigning: boolean;
};

const BankIdSigning = ({ signAction, isSigning }: Props) => {
	const [checked, setChecked] = useState(false);
	const [isSignPending, setIsSignPending] = useState<boolean>(false);
	const [t, texts] = useText();

	const handleSignAction = () => {
		setIsSignPending(true);
		void signAction().finally(() => {
			setIsSignPending(false);
		});
	};

	return (
		<>
			<div className="tablet:gap-4 laptop:flex-row laptop:gap-4 flex flex-col items-center justify-end gap-6 px-6">
				{!isSigning && (
					<div className="laptop:justify-start grow-0 items-center justify-center">
						<FormControlLabel label={t(texts.signPage.agreementCheckboxText)} gap={2}>
							<Checkbox
								checked={checked}
								onChange={() => {
									setChecked(!checked);
								}}
							/>
						</FormControlLabel>
					</div>
				)}
				<Button
					data-tracking-action="Sign Agreement"
					type="button"
					isDisabled={!checked}
					onPress={handleSignAction}
					isPending={isSignPending}
					iconStart="bankId"
				>
					{t(texts.signPage.signWithBankId)}
				</Button>
			</div>
			<SigningModal />
		</>
	);
};

export default BankIdSigning;
